import React from 'react';

import { Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

const Checkbox = ({ 'data-testid': dataTestId }) => {
  return (
    <div className="w-full flex items-center justify-between px-20" data-testid={dataTestId}>
      <Skeleton animation="pulse" className="mr-20" variant="rectangular" width="17px" />
      <Skeleton animation="pulse" variant="text" width="170px" />
    </div>
  );
};

Checkbox.propTypes = {
  'data-testid': PropTypes.string,
};

export default Checkbox;
